import { Injectable } from '@angular/core';

@Injectable()
export class InstaService {

  getPosts = function () {
    return fetch("https://www.instagram.com/benderhardware/?__a=1")
    .then(
      (res)=>res.json()
      .then((feed)=>feed.graphql.user.edge_owner_to_timeline_media.edges)
      .catch(err=>console.error(err))
    ).catch(console.error);
  }

  constructor() { }

}



// WEBPACK FOOTER //
// /tmp/build_fdb7fa8d/src/app/insta.service.ts